/**
 * Generated runtime TestId mirror for frontend/src/pages/reporting/ReportCategoriesPage.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ReportCategoriesPageTestIds = {
  btnCreateCategory: "btn-create-category",
  btnPickParentCategory: "btn-pick-parent-category",
  categoriesPage: "categories-page",
  colActions: "col-actions",
  colCategory: "col-category",
  colCategorySearch: "col-category-search",
  colLastModified: "col-last-modified",
  colLastModifiedSearch: "col-last-modified-search",
  colName: "col-name",
  colNameSearch: "col-name-search",
  colType: "col-type",
  colTypeSearch: "col-type-search",
  selectCategoryType: "select-category-type",
  btnSearch: (option_value: string) => `btn-search-${option_value}`,
  btnSearchPrefix: () => "btn-search-" as TestIdPrefix,
  reportSearchResult: (result_reportDefinitionId: string) => `report-search-result-${result_reportDefinitionId}`,
  reportSearchResultPrefix: () => "report-search-result-" as TestIdPrefix
} as const;
